import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5pzqc98s7c: FaireBrandEntity = {
  token: "b_5pzqc98s7c",
  type: "brand",
  name: "Explicit Essentials",
  avatarUrl:
    "https://cdn.faire.com/fastly/c6d980cf10c7cea47c2bbd414a2a1d816f9dfa0525c870334cc3d1c223e540e3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5c4e18244a8175840243814c07eaa903be97496727da7c36db63307103831e9d.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c6d980cf10c7cea47c2bbd414a2a1d816f9dfa0525c870334cc3d1c223e540e3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5c4e18244a8175840243814c07eaa903be97496727da7c36db63307103831e9d.png",
  location: "Knoxville, TN, USA",
  minimumOrderDollars: 100,
  rating: 4.8,
  reviewCount: 157,
  isTopShop: true,
  isInsider: true,
  description:
    "Founded in Queens, NYC we wanted to create badass products for badass women. We believe in keeping it 100% real in life and in our products. All of our products are handmade with only the best ingredients.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:33.378Z",
    importedBy: "entity-db-cli",
  },
};
